import { DateTime } from "luxon";
import { useParams } from "react-router";
import { BondNotFound } from "../../order/BondNotFound";
import { asCorporateBondId } from "@goodfill/domain-properties";
import { pricedBondState } from "../../../state";
import { useRecoilValue } from "recoil";
import { BondDetail } from "./BondDetail";
import { PageLayoutFixed } from "../../layouts/PageLayoutFixed";

export const BondDetailScreen = () => {
  const pricedBond = useRecoilValue(pricedBondState);
  const { bondId } = useParams();

  const tradeDate = DateTime.local();

  const selectedBondItem = bondId ? pricedBond.get(asCorporateBondId(bondId)) : undefined;

  return (
    <PageLayoutFixed>
      {selectedBondItem ? <BondDetail pricedBond={selectedBondItem} tradeDate={tradeDate} /> : null}
    </PageLayoutFixed>
  );
};
